import { css } from '../../../styled-system/css';
import { DropdownMenu } from '../DropdownMenu';
import { globalHeader } from '../../../styled-system/recipes';
import { useAuth } from '#/utils/auth/useAuth';

export function GlobalHeader() {
  const { isAuthenticated } = useAuth();
  const { headerLayout, logoLayout, zenidLogo, kadokawaGroupLogo } = globalHeader();
  return (
    <div className={headerLayout}>
      <div className={logoLayout}>
        <a href="/">
          <img
            className={zenidLogo}
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/zenid_logo.svg`}
            alt="ZEN IDロゴ"
          />
        </a>
        <img
          className={kadokawaGroupLogo}
          src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/kadokawa_group_logo.svg`}
          alt="KadokawaGroupのロゴ"
        />
      </div>
      {isAuthenticated && (
        <DropdownMenu className={css({ position: 'absolute', right: '8px', md: { right: '16px' } })} />
      )}
    </div>
  );
}
